import { useQuery } from '@tanstack/react-query';
import type { UseQueryOptions } from '@tanstack/react-query';
import { DEFAULT_LIMIT_REQUEST } from '@/Constants';
import { objectNotNullV2, removeNoNumeric } from '@/Utils/FnUtils';
import { apiClientOld } from '@/_config/lib/axios/api-client-old';
import { handleResponseThrowError } from '@/_utils/services';
import type { MotoboyList, MotoboysListParams } from '../types';
import { GET_MOTOBOYS_LIST } from '../constants';
import type { BaseRequestResponse } from '@/_types/services';

// TODO - remove method objectNotNullV2 and transformParams
const transformParams = (params: MotoboysListParams) => {
  const {
    limit,
    startDate,
    endDate,
    deliverymanId,
    status,
    name,
    cpf,
    cityId,
    cellphone,
    page,
    deliveryType,
  } = params || {};
  const newPage = page || 1;
  const newLimit = limit || DEFAULT_LIMIT_REQUEST;
  const offset = (newPage - 1) * newLimit;

  return objectNotNullV2({
    limit: newLimit,
    offset,
    cpf: cpf ? removeNoNumeric(cpf) : '',
    cellphone: cellphone ? removeNoNumeric(cellphone) : '',
    municipioId: cityId,
    entregadorId: deliverymanId,
    dataInicio: startDate ? new Date(startDate).toISOString() : '',
    dataFim: endDate ? new Date(endDate).toISOString() : '',
    nome: name,
    deliveryType,
    status,
  });
};

const getMotoboys = (params: MotoboysListParams) => {
  const objParams = transformParams(params);

  return apiClientOld
    .get<BaseRequestResponse<MotoboyList[]>>('/entregadores', {
      params: objParams,
    })
    .then(response => response as unknown as BaseRequestResponse<MotoboyList[]>)
    .catch(handleResponseThrowError());
};

type GetMotoboysListData = Awaited<ReturnType<typeof getMotoboys>>;

export const useGetMotoboysList = (
  params: MotoboysListParams,
  options: Omit<
    UseQueryOptions<
      GetMotoboysListData,
      unknown,
      GetMotoboysListData,
      (string | MotoboysListParams)[]
    >,
    'queryKey' | 'queryFn'
  > = {},
) => {
  return useQuery({
    queryKey: [GET_MOTOBOYS_LIST, params],
    queryFn: () => getMotoboys(params),
    ...options,
  });
};
